import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { useHandleNetworkError } from "utils/useHandleNetworkError";

export const useCreateSickCert = () => {
  const queryClient = useQueryClient();
  const handleNetworkError = useHandleNetworkError("Error while saving sick cert");
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useMutation({
    mutationFn: async (sickCertData) => {
      const axiosInstance = await createAxiosInstance();
      const response = await axiosInstance.post(
        `${tenantVal}/patientsickcert`,
        sickCertData
      );

      return response.data;
    },
    // No success toast here. The form saves silently in the background — opening
    // the template picker saves first so the server substitutes placeholders from
    // the current field values — and a "saved successfully!" on a click the user
    // reads as "show me the templates" is a claim about something they didn't ask
    // for. AddSickCertForm toasts for the saves the user actually initiated.
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["activeConsultationSickCert"] });
    },
    onError: handleNetworkError,
  });
};
